<template lang="pug">
    extends ../base/base.pug
    block input
        b-form-checkbox(
            :id="slug + multi_field_num"
            v-model="local_answer"
            @change="process_change()"
            :required="is_required"
        )
            div(v-if="!hide_label")
                = '{{ question }}'
                span(
                    v-if="is_required"
                    class="requiredField"
                ) *
        b-form-invalid-feedback
            = '{{ error_message }}'
        b-form-text
            = '{{ helper }}'
</template>
<script>
import Base from "../base";

export default {
	extends: Base,
	props: {
		hide_label: Boolean
	}
};
</script>
